<template>
  <div id="Register">
    <div class="register_box">
      <Title title_name="會員註冊填寫"></Title>
      <div class="register_content">
        <form>
          <InputBox v-for="(item, index) in input_info.slice(3, 4)" :key="item.input_id" :input_info="input_info.slice(3, 4)[index]" :flag="flag" @input_content="input_content"></InputBox>
          <InputBox v-for="(item, index) in input_info.slice(4, 6)" :key="item.input_id" :input_info="input_info.slice(4, 6)[index]" :pwd_check="pwd_check" :flag="flag" @input_content="input_content"></InputBox>
          <InputBox v-for="(item, index) in input_info.slice(6, 10)" :key="item.input_id" :input_info="input_info.slice(6, 10)[index]" :flag="flag" @input_content="input_content"></InputBox>
          <div class="sms_message">
            <a href="javascript:void(0);" @click="get_sms" :class="{'no_click' : sec !=0 }">取得驗證碼</a>&nbsp;
            <span v-if="sec!=0">下次發送{{sec}}秒</span>
          </div>
          <div class="agree_box">
            <input type="checkbox" v-model="agree">
              <span> 同意 <router-link to="/register/contract" target="_blank">會員服務使用條款</router-link></span>
          </div>
        </form>
      </div>
      <div>
        <MoreButton button_text="註冊會員" button_href="javascript:void(0);" @click.native="submit_register" :loading="loading"></MoreButton>
      </div>
    </div>
  </div>
</template>
<script>
import Title from '@/components/base/Title'
import InputBox from '@/components/base/InputBox'
import MoreButton from '@/components/base/MoreButton'
export default {
  name: 'register',
  components: {
    Title: Title,
    InputBox: InputBox,
    MoreButton: MoreButton
  },
  data() {
    return {
      input_info: require("@/plugins/input_info"), // input資料
      register_data: new FormData(), // 最後送出的資料
      member_info: {
        email: '',
        password: '',
        password_check: '',
        name: '',
        phone_number:'',
        verify_code: '',
        cid: '',
      },
      flag: {}, // 檢查表單是否正確填寫 True False
      submit_flag: null,
      pwd_check: true, //檢查再次輸入密碼
      agree: false, // checkbox
      sec: 0, // 簡訊重發秒數
      loading: false,
    }
  },
  watch: {
    // 驗證密碼是否一樣
    'member_info.password_check': function (v) {
      (v == this.member_info.password) ? this.pwd_check = true : this.pwd_check = false
    },
    'member_info.password': function (v) {
      (v == this.member_info.password_check) ? this.pwd_check = true : this.pwd_check = false
    }
  },
  computed: {
    API() {
      return process.env.NODE_ENV === "production" ? "https://www.top-link.com.tw/" : "http://localhost/";
    },
  },
  methods: {
    input_content(v){
      this.member_info[v[1]] = v[0];
      this.register_data.set(v[1], v[0])
      this.validForm()
    },
    get_sms(){
      var vm = this
      var sms_api = vm.API + "api/sms/get_verify_code"
      var verity_data = new FormData()
      verity_data.append("phone_number", vm.member_info.phone_number)
      // console.log(vm.verity_data)
      if(vm.member_info.phone_number==""){
        alert("手機號碼不可為空")
      } else{
          vm.axios.post(sms_api, verity_data).then(res => {
          // console.log(res)
          if(res.data.status == 200){
            vm.sec = parseInt(res.data.data.expired_sec)
            alert(res.data.message)
            // 簡訊發送後開始倒數
            var interval = setInterval(() => {
              if(vm.sec==0){ clearInterval(interval) }
              else { vm.sec-- }
            }, 1000);
          } else{
            alert("錯誤碼: " + " " + res.data.status + res.data.message)
          }
        })
      }
    },
    submit_register(){
      var vm = this
      var register_api = vm.API + 'api/member/register'
      // 檢查表單是否正確
      if(!vm.submit_flag){
        alert("表單輸入有誤，請重新檢查")
      } else if (!vm.pwd_check){
        alert("密碼輸入不一致，請重新檢查")
      } else if (!vm.agree){
        alert("請詳細閱讀使用條款後勾選同意") 
      } else {
        // 送出表單
        vm.loading = true
        vm.axios.post(register_api, vm.register_data).then(res => {
          // console.log(res)
          if(res.data.status == 200){
            vm.loading = false
            // 因為 push 帶 path 和 params ， params 會失效，故使用 name 代替 push
            vm.$router.push({name: 'register_ok', params: {email: vm.member_info.email}})
          } else{
            var alr = ""
            switch(res.data.status){
              case 600:
                alr = "請確認表單是否正確填寫"
                break
              default:
                alr = res.data.message
            }
            alert("錯誤碼: " + res.data.status + "  " + alr)
            vm.loading = false
            vm.$router.push({name: 'register_ok', params: {email: vm.member_info.email}})
          }
        }).catch(function(error) {
          console.log(error)
        })
      }
    },
    validForm() {
      var vm = this
      var reg = new RegExp()
      let flag = null
      for(var index in vm.member_info){
        // 建立正規式
        switch(index){
          case 'email':
            // eslint-disable-next-line
            reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            break
          case 'phone_number':
            reg = /^09[0-9]{8}$/
            break
          case 'password':
            reg = /^\w{6,12}$/
            break
          case 'password_check':
            reg = /^\w{6,12}$/
            break
          case 'cid':
            reg = /^[0-9]{6}$/
            break
          case 'verify_code':
            reg = /^[0-9]{6}$/
            break
          default:
            reg = /./
        }
        flag = reg.test(vm.member_info[index])
        vm.$set(vm.flag, index, flag)
      }
      for(var temp in vm.flag){
        if(!vm.flag[temp]){
          vm.submit_flag = false
          return 0
        } else {
          vm.submit_flag = true
        }
      }
      // console.log(vm.flag)
      // return true
    }
  },
}
</script>
<style>
  .register_box{
    width: 650px;
    max-width: 100%;
    margin: auto;
    padding: 20px;
  }
  .sms_message{
    margin: 20px 0;
  }
  .sms_message a{
    color: #8484ee;
    font-weight: 700;
    padding: 10px;
    border-radius: 10px;
    border: 2px solid #8484ee;
    transition: all .3s;
  }
  .sms_message a:hover{
    color: #ffffff;
    background: #8484ee
  }
  .no_click{
    pointer-events: none;
    color: #cecece !important;
    border-color: #cecece !important;

  }
  .agree_box{
    padding: 12px 0;
    text-align: center;
  }
</style>